/**
 * The bundled docs (DOCS_CONTRACT.md): one `docs.<locale>.json` per language,
 * copied in from the landing build by `npm run docs:sync`. Bundled, so Help
 * works offline; only videos and screenshots come from the CDN.
 */
import docsEn from './content/docs.en.json';
import docsDe from './content/docs.de.json';

const BY_LOCALE = { en: docsEn, de: docsDe };

/** The docs for a UI language, falling back to English. */
export function docsFor(locale) {
  const key = String(locale || 'en').slice(0, 2).toLowerCase();
  return BY_LOCALE[key] || BY_LOCALE.en;
}

/**
 * Sections with their pages sorted by `order`, and a flat page list where each
 * page knows its section — what the nav, search and deep links work from.
 */
export function indexDocs(docs) {
  const sections = (docs?.sections || []).map((section) => ({
    ...section,
    pages: [...(section.pages || [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
  }));
  const pages = [];
  for (const section of sections) {
    for (const page of section.pages) pages.push({ ...page, section });
  }
  return { sections, pages, byId: new Map(pages.map((p) => [p.id, p])) };
}

/**
 * Pages matching a query: every word must appear in the title, the summary or
 * a heading. Case-insensitive. An empty query matches everything.
 */
export function searchPages(pages, query) {
  const words = String(query || '')
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) return pages;
  return pages.filter((page) => {
    const hay = [page.title, page.summary, ...(page.headings || []).map((h) => h.text)]
      .filter(Boolean)
      .join(' \n ')
      .toLowerCase();
    return words.every((w) => hay.includes(w));
  });
}

/** The heading id for a heading's text on a page (contract ids first). */
export function headingIdFor(page, text, level) {
  const found = (page?.headings || []).find((h) => h.text === text && (!level || h.level === level));
  if (found) return found.id;
  return String(text)
    .toLowerCase()
    .replace(/<[^>]+>/g, '')
    .replace(/[^a-z0-9À-ɏ]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
